import { jsx, jsxs } from "react/jsx-runtime";
import { ContentBlock, Stack } from "braid-design-system";
import { getParentProductsAndAddons, getProductsForDisplay, Wrapper, getProductIsSelectedLoading, Disclaimer } from "../GridLayout/GridLayout.mjs";
import { RowPanel } from "../../panels/RowPanel/RowPanel.mjs";
import { GridRow } from "../shared/components/Grid/GridRow/GridRow.mjs";
import { Upsells } from "../shared/components/Upsells/Upsells.mjs";
import { getPanelStyle } from "../shared/utils/getPanelStyle/getPanelStyle.mjs";
import { rowPanel } from "../shared/SharedLayout.css.mjs";
const RowLayout = ({
  products,
  selectedProductIds,
  loadingProductIds,
  onProductSelect,
  prefixContent,
  hideDisclaimer
}) => {
  const { selectedParentProduct, singleParentProduct, addOnsList } = getParentProductsAndAddons({
    products,
    selectedProductIds
  });
  const { adProducts, addOnProductsList, upsellProducts, allProducts } = getProductsForDisplay({
    parentProducts: products,
    addOns: addOnsList,
    singleParentProduct
  });
  return /* @__PURE__ */ jsx(Wrapper, { products, children: /* @__PURE__ */ jsx(ContentBlock, { children: /* @__PURE__ */ jsxs(Stack, { space: "large", children: [
    adProducts.length > 0 && (prefixContent == null ? void 0 : prefixContent.products) && /* @__PURE__ */ jsx(GridRow, { children: prefixContent.products }),
    adProducts.length > 0 && /* @__PURE__ */ jsx(Stack, { space: "medium", children: adProducts.map((product) => {
      const isCurrentProduct = product.purchaseState === "PURCHASED";
      const { isSelected, isLoading } = getProductIsSelectedLoading({
        selectedProductIds,
        loadingProductIds,
        product,
        forceSelected: isCurrentProduct && !selectedParentProduct || product.id === (selectedParentProduct == null ? void 0 : selectedParentProduct.id)
      });
      return /* @__PURE__ */ jsx(
        GridRow,
        {
          className: [
            rowPanel,
            getPanelStyle({
              panel: product.panel,
              isSelected,
              isCurrentProduct,
              productType: product.type
            })
          ],
          children: /* @__PURE__ */ jsx(
            RowPanel,
            {
              product,
              isSelected,
              isLoading,
              onSelect: onProductSelect
            }
          )
        },
        product.id
      );
    }) }),
    (addOnProductsList.length > 0 || upsellProducts.length > 0) && /* @__PURE__ */ jsx(
      Upsells,
      {
        singleParentProduct,
        addOnProductsList,
        upsellProducts,
        onProductSelect,
        prefixContent,
        selectedProductIds,
        loadingProductIds
      }
    ),
    allProducts.length > 0 && !hideDisclaimer && /* @__PURE__ */ jsx(GridRow, { children: /* @__PURE__ */ jsx(Disclaimer, { products }) })
  ] }) }) });
};
export {
  RowLayout
};
